// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.notes-history-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 10px;
    max-height: 400px;
  }
  
  /* Calendar Section */
  .notes-history-calendar {
    width: 50%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    overflow-y: auto;
  }
  
  /* Notes Section */
  .notes-history-notes-section {
    width: 50%;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    overflow-y: auto;
  }
  
  /* Individual Note */
  .notes-history-note {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  /* Present Button */
  .notes-history-present-button {
    margin-top: 10px;
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .notes-history-present-button:hover {
    background-color: #0056b3;
  }`, "",{"version":3,"sources":["webpack://./src/styles/NotesHistoryWidget.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,UAAU;IACV,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA,mBAAmB;EACnB;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Main Container */\n.notes-history-container {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    padding: 10px;\n    max-height: 400px;\n  }\n  \n  /* Calendar Section */\n  .notes-history-calendar {\n    width: 50%;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px;\n    overflow-y: auto;\n  }\n  \n  /* Notes Section */\n  .notes-history-notes-section {\n    width: 50%;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px;\n    overflow-y: auto;\n  }\n  \n  /* Individual Note */\n  .notes-history-note {\n    padding: 10px;\n    margin-bottom: 10px;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Present Button */\n  .notes-history-present-button {\n    margin-top: 10px;\n    padding: 10px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .notes-history-present-button:hover {\n    background-color: #0056b3;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
